module.exports = __webpack_public_path__ + "img/ISR.6a427cad.png";